import { api } from "./api";

export async function fetchMiMembresia() {
  const { data } = await api.get("/pagos/mi-membresia");
  return data; // { plan, vigente_hasta }
}

export async function fetchBeneficios() {
  const { data } = await api.get("/pagos/beneficios");  return data; // { plan, descuento_pct, pilares, destacados_gratis_mes, destacados_gratis_restantes }
}

export async function fetchMembershipBenefits() {
  const { data } = await api.get("/memberships/benefits");
  return data; // { moneda, planes: [{ id, nombre, precio, precio_label, periodo, badge, grupos:[{pilar, beneficios[]}] }] }
}

export async function checkoutMembresia(plan) {
  const { data } = await api.post("/pagos/checkout/membresia", {
    plan,
    origin_url: window.location.origin,
  });
  return data; // { url, session_id }
}

export async function checkoutDestacar(publicacionId, dias) {
  const { data } = await api.post("/pagos/checkout/destacar", {
    publicacion_id: publicacionId,
    dias: String(dias),
    origin_url: window.location.origin,
  });
  return data;
}

// ---------- Licencias de Programas Especializados (F2) ----------
export async function fetchProgramasLicenciables() {
  const { data } = await api.get("/software/programas/licenciables");
  return data; // [{ id, slug, name, ..., precios:{moneda,m3,m6,m12{centimos,soles,ahorro_pct}} }]
}

export async function fetchMiLicencia(slug) {
  const { data } = await api.get(`/software/mi-licencia/${slug}`);
  return data; // { estado, fecha_vencimiento, dias_restantes, duracion_meses, codigo, ... }
}

export async function checkoutLicencia(slug, duracionMeses) {
  const { data } = await api.post(`/software/licencias/checkout/${slug}`, {
    duracion_meses: Number(duracionMeses),
    origin_url: window.location.origin,
  });
  return data; // { url, session_id }
}

export async function fetchEstadoPago(sessionId) {
  const { data } = await api.get(`/pagos/status/${sessionId}`);
  return data;
}

// Poll de estado (máx ~10 intentos cada 2s)
export async function pollEstadoPago(sessionId, onUpdate, intentos = 0) {
  const MAX = 10;
  if (intentos >= MAX) return { payment_status: "timeout" };
  const d = await fetchEstadoPago(sessionId);
  onUpdate?.(d);
  if (d.payment_status === "paid" || d.status === "expired") return d;
  await new Promise((r) => setTimeout(r, 2000));
  return pollEstadoPago(sessionId, onUpdate, intentos + 1);
}
